import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

import Channels from './channels';
import Streams from './streams';
import Interaction from './interaction';

class App extends Component {
	constructor(props) {
		super(props);
		this.handleOnline = this.handleOnline.bind(this);
		this.handleOffline = this.handleOffline.bind(this);
	}

	componentDidMount() {
		const { targetAlias } = this.props;
		document.title = `Zender Live Studio - ${targetAlias}`;
		window.addEventListener('online', this.handleOnline);
		window.addEventListener('offline', this.handleOffline);
	}

	componentWillUnmount() {
		window.removeEventListener('online', this.handleOnline);
		window.removeEventListener('offline', this.handleOffline);
	}

	handleOffline() {
		this.props.createNotification({
			type: 'error',
			title: 'Geen internet connectie',
			timeOut: 120000,
			priority: true,
		});
	}

	handleOnline() {
		this.props.createNotification({
			type: 'success',
			title: 'Internet is terug',
			timeOut: 30000,
			priority: true,
		});
	}

	render() {
		return (
			<div className="h-100 d-flex flex-column justify-content-center">
				<NotificationContainer />
				<Route exact path="/:targetAlias" component={Channels} />
				<Route exact path="/:targetAlias/channels/:channelId" component={Streams} />
				<Route
					exact
					path="/:targetAlias/channels/:channelId/streams/:streamId/:type?"
					component={Interaction}
				/>
			</div>
		);
	}
}

App.propTypes = {
	targetAlias: PropTypes.string.isRequired,
	createNotification: PropTypes.func.isRequired,
};

App.defaultProps = {};

export default App;



// WEBPACK FOOTER //
// ./src/ui/App.component.js